var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_830_2338)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3896 4.81818L11.131 11.8182H8.86399L8.60547 4.81818H11.3896ZM9.99751 15.1591C9.61304 15.1591 9.28326 15.0249 9.00817 14.7564C8.73639 14.4846 8.60215 14.1548 8.60547 13.767C8.60215 13.3892 8.73639 13.0661 9.00817 12.7976C9.28326 12.5291 9.61304 12.3949 9.99751 12.3949C10.3621 12.3949 10.6836 12.5291 10.962 12.7976C11.2437 13.0661 11.3862 13.3892 11.3896 13.767C11.3862 14.0256 11.3183 14.2609 11.1857 14.473C11.0565 14.6818 10.8874 14.8492 10.6786 14.9751C10.4698 15.0978 10.2428 15.1591 9.99751 15.1591Z",
    fill: "#1B1B1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_2338",
    x1: -1.58416,
    y1: -4.36623,
    x2: 20.7265,
    y2: -3.98322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.cbb404b3da9b63e8af260889040ac8da.svg";
export { ForwardRef as ReactComponent };